import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import OnboardingPage from "@/pages/OnboardingPage";
import DashboardLayout from "@/pages/DashboardLayout";
import ChatPage from "@/pages/ChatPage";
import SimulatorPage from "@/pages/SimulatorPage";
import RiskPage from "@/pages/RiskPage";
import ChecklistPage from "@/pages/ChecklistPage";
import QuizPage from "@/pages/QuizPage";
import GlossaryPage from "@/pages/GlossaryPage";
import TimelinePage from "@/pages/TimelinePage";
import DiagnosticPage from "@/pages/DiagnosticPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import PricingPage from "@/pages/PricingPage";
import AdminPage from "@/pages/AdminPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import LegalPage from "@/pages/LegalPage";
import ProfilePage from "@/pages/ProfilePage";
import SearchPage from "@/pages/SearchPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center"><div className="h-8 w-8 border-2 border-[var(--ia-navy)] border-t-transparent rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function GuestRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center"><div className="h-8 w-8 border-2 border-[var(--ia-navy)] border-t-transparent rounded-full animate-spin" /></div>;
  if (user) return <Navigate to={user.onboarded ? "/dashboard" : "/onboarding"} replace />;
  return children;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<GuestRoute><LoginPage /></GuestRoute>} />
      <Route path="/register" element={<GuestRoute><RegisterPage /></GuestRoute>} />
      <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccessPage /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route index element={<ChatPage />} />
        <Route path="chat" element={<ChatPage />} />
        <Route path="simulator" element={<SimulatorPage />} />
        <Route path="risks" element={<RiskPage />} />
        <Route path="checklist" element={<ChecklistPage />} />
        <Route path="quiz" element={<QuizPage />} />
        <Route path="glossary" element={<GlossaryPage />} />
        <Route path="timeline" element={<TimelinePage />} />
        <Route path="diagnostic" element={<DiagnosticPage />} />
        <Route path="case-studies" element={<CaseStudiesPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="pricing" element={<PricingPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>
      <Route path="/legal" element={<LegalPage />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
